import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import ProtectedRoute from "./components/ProtectedRoute";
import MainLayout from "./components/MainLayout";

import AuthPage from "./pages/AuthPage";
import AuthCallback from "./pages/AuthCallback";
import Onboarding from "./pages/Onboarding";
import Startup from "./pages/Startup";

import ImageFoodScanner from "./pages/ImageFoodScanner";
import QuickAdd from "./pages/QuickAdd";

import Setgoal from "./pages/Goal/Setgoal";
import Water from "./pages/Goal/Watergoal";
import Sleep from "./pages/Goal/Sleepgoal";
import Weight from "./pages/Goal/Weightgoal";
import Steps from "./pages/Goal/Stepsgoal";

import PremiumPage from "./pages/PremiumPage";
import PrivacyPolicy from "./pages/Profiles/PrivacyPolicy";
import PersonalInfo from "./pages/Profiles/PersonalInfo";
import HelpCircle from "./pages/Profiles/Helpandfaq";
import Feedback from "./pages/Profiles/feedback";

import { useAuth } from "./contexts/AuthContext";

function App() {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-white">
        <div className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <Routes>
      {/* ENTRY */}
      <Route path="/" element={<Startup />} />

      {/* PUBLIC */}
      <Route path="/auth" element={!user ? <AuthPage /> : <Navigate to="/" replace />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/help-faq" element={<HelpCircle />} />
       <Route path="/feedback" element={<Feedback />} />

      {/* ONBOARDING */}
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute>
            {!profile?.onboarding_complete ? (
              <Onboarding />
            ) : (
              <Navigate to="/dashboard" replace />
            )}
          </ProtectedRoute>
        }
      />

      {/* MAIN APP (NO /app PREFIX) */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            {!profile?.onboarding_complete ? (
              <Navigate to="/onboarding" replace />
            ) : (
              <MainLayout />
            )}
          </ProtectedRoute>
        }
      />

      {/* STANDALONE */}
      <Route path="/scan" element={<ProtectedRoute><ImageFoodScanner /></ProtectedRoute>} />
      <Route path="/quick-add" element={<ProtectedRoute><QuickAdd /></ProtectedRoute>} />
      <Route path="/set-goal" element={<ProtectedRoute><Setgoal /></ProtectedRoute>} />
      <Route path="/water" element={<ProtectedRoute><Water /></ProtectedRoute>} />
      <Route path="/sleep" element={<ProtectedRoute><Sleep /></ProtectedRoute>} />
      <Route path="/weight" element={<ProtectedRoute><Weight /></ProtectedRoute>} />
      <Route path="/steps" element={<ProtectedRoute><Steps /></ProtectedRoute>} />

      <Route path="/personal-info" element={<ProtectedRoute><PersonalInfo /></ProtectedRoute>} />
      <Route path="/premium" element={<ProtectedRoute><PremiumPage /></ProtectedRoute>} />

      {/* FALLBACK */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
